module.exports = __webpack_public_path__ + "img/L1_zoom.13e1b913.svg";